import React from "react";
import PropTypes from "prop-types";
import { BarItem } from "./BarItem";

export function ProgressBar(props) {
  const totalBars = props.progressBars.length;

  const getBarItemStyle = () => ({ width: `calc( 100%/${totalBars} )` });

  const renderProgressBar = (barItem, key) => (
    <BarItem
      key={key}
      onClick={props.setTaskVisible}
      taskId={barItem.id}
      filled={barItem.filled}
      style={getBarItemStyle()}
    />
  );

  return (
    <div className="progressbar">
      <div className="progressbar_barlist">
        {props.progressBars.map(renderProgressBar)}
      </div>
      <div className="progressbar_info">
        <p>
          {props.current}/{totalBars}
        </p>
      </div>
    </div>
  );
}

ProgressBar.propTypes = {
  /**
   * List of data to render the progress bar
   */
  progressBars: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Id for the task
       */
      id: PropTypes.number,
      /**
       * boolean to show progression of step
       */
      filled: PropTypes.bool,
    })
  ),
  /**
   * Index of currently active progressbar Item
   */
  current: PropTypes.number,
  /**
   * Function for set a task visible
   */
  setTaskVisible: PropTypes.func,
};

ProgressBar.defaultProps = {};
